import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { ReactComponent as DeleteProduct } from "../../assets/img/ctaIcons_Delete.svg";
import { ReactComponent as AddProduct } from "../../assets/img/settingsIcon_Auto.svg";
import { ReactComponent as SubMenuDots } from "../../assets/img/subMenu_Dots.svg";
// import { ReactComponent as ShopifyIcon } from "../../assets/img/Shopify_LogoMark.svg";
// import Tooltip from "@material-ui/core/Tooltip";

export default function AccountMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <SubMenuDots />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        className="product-edit-delete-dropdown"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={props.onEditClick}>
          <ListItemIcon>
            <AddProduct fontSize="small" />
          </ListItemIcon>
          Edit Product
        </MenuItem>
        <MenuItem className="delete-product" onClick={props.onDeleteClick}>
          <ListItemIcon>
            <DeleteProduct fontSize="small" />
          </ListItemIcon>
          Delete Product
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
